<mat-form-field class="keyword-chip-list">
  <mat-label>Tags</mat-label>
  <mat-chip-list #chipList>
    <mat-chip
      *ngFor="let keyword of keywords"
      (removed)="remove(keyword)">
      {{keyword}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    <input
      placeholder="New keyword..."
      #keywordInput
      [formControl]="keywordCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)">
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let word of filteredKeywords | async |slice:0:5" [value]="word">
      {{word}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
